import { render, staticRenderFns } from "./ProfileIdentStandardVolunteerForm.vue?vue&type=template&id=490856ae"
import script from "./ProfileIdentStandardVolunteerForm.vue?vue&type=script&lang=ts"
export * from "./ProfileIdentStandardVolunteerForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIdentStandardVolunteerForm.vue?vue&type=style&index=0&id=490856ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports